module.exports = __webpack_public_path__ + "img/2023-01-09e_3.74b3855f.jpg";